import apiRoutes from "../../Routes/Routes.json";
import HttpClient from "../../HttpClient";

export const GetToxPanelTypes = () => {
  return HttpClient().get(`${apiRoutes.LeveyJennings.GetTOXPanelTypesLookup}`);
};

export const GetTOXSpecimenTypesLookup = () => {
  return HttpClient().get(
    `${apiRoutes.LeveyJennings.GetTOXSpecimenTypesLookup}`
  );
};

export const LeveyJenningDownloadReport = (payload: any) => {
  return HttpClient().post(
    `/${apiRoutes.LeveyJennings.DownloadReport}`,
    payload
  );
};

export const GetBloodTestsLookup = (payload: any) => {
  return HttpClient().post(
    `/${apiRoutes.LeveyJennings.GetBloodTests}`,
    payload
  );
};

export const GetTOXAndBloodInstrumentsLookup = (
  reqTypeId: number,
  panelTypeId: number
) => {
  return HttpClient().get(
    `${apiRoutes.LeveyJennings.GetTOXAndBloodInstrumentsLookup}/${reqTypeId}/${panelTypeId}`
  );
};

export const GetTestsLookup = (
  specimenTypeId: number,
  panelTypeId: number,
  reqTypeId: number
) => {
  return HttpClient().get(
    `${apiRoutes.LeveyJennings.GetTestsLookup}/${specimenTypeId}/${panelTypeId}/${reqTypeId}`
  );
};

export const QCLevelsLookup = (
  reqTypeId: number,
  instrumentId: number,
  panelTypeId: number,
  specimenTypeId: number
) => {
  return HttpClient().get(
    `${apiRoutes.LeveyJennings.QCLevelsLookup}/${reqTypeId}/${instrumentId}/${panelTypeId}/${specimenTypeId}`
  );
};
